"use client"

import { useState ,useEffect} from "react"
import Cookies from "js-cookie"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

export default function Navbar() {
  const [username, setUsername] = useState("Admin");
  const navigate = useNavigate();

  useEffect(()=>{
    const username = Cookies.get("username")
    if (username) {
      setUsername(username);
    }
  })

  const LogOut = () => {
    Cookies.remove("token");
    Cookies.remove("userId");
    Cookies.remove("username");
    toast.info("Logged out successfully");
    navigate("/");
  }

  return (
    <header className="navbar navbar-expand navbar-dark bg-black px-4 py-2 shadow-sm ">
      <a className="navbar-brand d-flex align-items-center justify-content-center" href="https://prowesserp.com" style={{color:'white'}} target="_blank" rel="noreferrer">
        <span className="fw-bold fs-4"><img src="./prowess-logo-white.png" alt="Prowess logo" height={50}/></span>
        {/* <span className="fw-bold fs-4"><img src="./favicon.jpg" alt="Prowess logo" height={30}/> &nbsp;PROWESS ERP</span> */}
      </a>

      <div className="ms-auto d-flex align-items-center">

        <div className="dropdown">
          <button
            className="btn btn-white dropdown-toggle d-flex align-items-center"
            type="button"
            id="userDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{color:'white'}}
          >
            
            <i className="bi bi-person-fill me-2" style={{fontSize:'30px',color:'white'}}></i>

            <span style={{color:'white'}}>{username}</span>
          </button>
          <ul className="dropdown-menu dropdown-menu-end text-white" aria-labelledby="userDropdown"  style={{color:'white'}} >
            <li>
              <a className="dropdown-item" style={{cursor:'pointer'}}>
                Profile
              </a>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <a className="dropdown-item" onClick={LogOut}  style={{cursor:'pointer'}}>
                Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  )
}

